// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function image_attributes_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
  if (url.TAG === /* Ok */0) {
    var alternativeText = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "alternativeText"), null));
    if (alternativeText.TAG === /* Ok */0) {
      var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
      if (name.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  url: url._0,
                  alternativeText: alternativeText._0,
                  name: name._0
                }
              };
      }
      var e = name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".name" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = alternativeText._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".alternativeText" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = url._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".url" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function image_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = image_attributes_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function optional_image_src_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = Decco.optionFromJson(image_data_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function image_src_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = image_data_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function image_short_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var alt_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "alt_text"), null));
  if (alt_text.TAG === /* Ok */0) {
    var src_path = image_attributes_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "src_path"), null));
    if (src_path.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                alt_text: alt_text._0,
                src_path: src_path._0
              }
            };
    }
    var e = src_path._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".src_path" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = alt_text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".alt_text" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function image_long_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var alt_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "alt_text"), null));
  if (alt_text.TAG === /* Ok */0) {
    var src_path = image_src_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "src_path"), null));
    if (src_path.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                alt_text: alt_text._0,
                src_path: src_path._0
              }
            };
    }
    var e = src_path._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".src_path" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = alt_text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".alt_text" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function image_single_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var alt_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "alt_text"), null));
  if (alt_text.TAG === /* Ok */0) {
    var image = image_src_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
    if (image.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                alt_text: alt_text._0,
                image: image._0
              }
            };
    }
    var e = image._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".image" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = alt_text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".alt_text" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function image_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var alt_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "alt_text"), null));
  if (alt_text.TAG === /* Ok */0) {
    var image = image_attributes_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
    if (image.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                alt_text: alt_text._0,
                image: image._0
              }
            };
    }
    var e = image._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".image" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = alt_text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".alt_text" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function img_attributes_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var alternativeText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "alternativeText"), null));
  if (alternativeText.TAG === /* Ok */0) {
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                alternativeText: alternativeText._0,
                url: url._0
              }
            };
    }
    var e = url._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".url" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = alternativeText._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".alternativeText" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var emptyImage = {
  alt_text: "",
  image: {
    url: "",
    alternativeText: undefined,
    name: ""
  }
};

export {
  image_attributes_decode ,
  image_data_decode ,
  optional_image_src_decode ,
  image_src_decode ,
  image_short_decode ,
  image_long_decode ,
  image_single_decode ,
  image_decode ,
  img_attributes_decode ,
  emptyImage ,
}
/* No side effect */
